import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null, status: 'idle', error: null };

const leaveFamilySlice = createSlice({
  name: 'leaveFamily',
  initialState,
  reducers: {
    leaveFamilyRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    leaveFamilySuccess(state, action) {
      state.status = 'succeeded';
      state.data = action.payload;
    },
    leaveFamilyFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    leaveFamilyReset(state) {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
});

export const leaveFamilyAction = leaveFamilySlice.actions;
export default leaveFamilySlice;